<template>
  <b-modal
    id="modal-answers-rejected-video"
    body-class="pt-2"
    hide-footer
    size="xl"
    header-class="align-items-center"
  >
    <template #modal-header="{ close }">
      <h5 class="mb-0">Video Rechazado</h5>
      <b-button
        variant="text"
        @click="closeModal"
        class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
        style="min-height: 24px"
      >
        <i
          class="ri-close-line hp-text-color-dark-0 lh-1"
          style="font-size: 24px"
        ></i>
      </b-button>
    </template>
    <section style="text-align: center;" v-if="answersRejectedVideo.length > 0 ">
      
      <video
        class="mx-auto mb-3 mt-5"
        width="80%"
        height="300"
        controls
      >
        <source
          :src="answersRejectedVideo[0].image"
          :type="getMimeTypeFromUrl(answersRejectedVideo[0].image)"
        />
      </video>
      <br />
      <div class="mx-auto text-center">
        <p
          class="mt-3"
          v-if="getCurrentAnswer && getCurrentAnswer.rejected_comment"
        >
          Motivo de rechazo:
          <br />
          <small class="font-weight-bold">
            {{
              getCurrentAnswer.rejected_comment
                ? getCurrentAnswer.rejected_comment
                : "No especificado"
            }}
          </small>
        </p>
        <p class="mt-3" v-if="getCurrentAnswer && getCurrentAnswer.rejected_at">
          Rechazado el:
          <br />
          <small class="font-weight-bold">
            {{
              moment(getCurrentAnswer.rejected_at).format(
                "DD/MM/YYYY HH:mm [hrs]"
              )
            }}
          </small>
        </p>
        <p v-if="getCurrentAnswer && getCurrentAnswer.rejected_by">
          Rechazada por:
          <br />
          <small class="font-weight-bold">
            {{
              getCurrentAnswer.rejected_by.first_name
                ? `${getCurrentAnswer.rejected_by.first_name} ${getCurrentAnswer.rejected_by.last_name}`
                : "Super Administrador"
            }}
          </small>
        </p>
        <div
          class="d-flex flex-row flex-wrap align-items-center justify-content-center"
        >
          <b-button
            v-if="isActiveRetrieved"
            v-show="
              currentUser &&
              checkIfHaveRole(currentUser.rol, [
                ROLES.inspector,
                ROLES.coordinator,
                ROLES.superadmin,
              ])
            "
            @click="openModalRetrieveAnswer"
            variant="warning"
            class="mt-2"
          >
            Recuperar video
          </b-button>
        </div>
      </div>
    </section>
    <br />
    <div class="d-flex justify-content-end flex-wrap mt-32">
      <b-button variant="outline-info-3" @click="closeModal"> Cerrar </b-button>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import { EXTENSION_VIDEO_MAP, VIDEO_EXTENSIONS } from "@/constants/common";
import { geExtensionFileFromUrl } from "@/utils/common";
import { verifyRole } from "@/mixins/role";

export default {
  mixins: [verifyRole],
  props: {
    answersRejectedVideo: {
      type: Array,
      default: () => [],
    },
    isActiveRetrieved: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      moment,
      loading: false,
      loadingMarkReplaced: false,
      slide: 0,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getCurrentAnswer() {
      return this.answersRejectedVideo[this.slide]
        ? this.answersRejectedVideo[this.slide]
        : null;
    },
  },
  methods: {
    ...mapActions({
      retrieveAnswer: "question/retrieveAnswer",
      sendMarkAnswerReplaced: "question/markAnswerReplaced",
    }),
    emitReplacementImage() {
      this.$emit("replaceCurrrentImage", this.getCurrentAnswer.id);
    },
    ifAnswerIsUploadedByUserAuth() {
      const currentImage = this.getCurrentAnswer;
      if (currentImage) {
        const { place_user } = currentImage;
        return place_user.customuser.id === this.currentUser?.id;
      }
    },
    closeModal() {
      this.$bvModal.hide("modal-answers-rejected-video");
    },
    getMimeTypeFromUrl(url) {
      const extension = geExtensionFileFromUrl(url);
      return EXTENSION_VIDEO_MAP[extension];
    },
    openModalRetrieveAnswer() {
      let self = this;
      this.$bvModal
        .msgBoxConfirm(
          "¿Estás seguro de recuperar este video?. El video se podrá ver nuevamente en las respuestas",
          {
            title: "Atención",
            size: "sm",
            buttonSize: "sm",
            okVariant: "warning",
            okTitle: "Recuperar",
            cancelTitle: "Cancelar",
            cancelVariant: "outline-info-3",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value) {
            console.log("getCurrentAnswer video", self.getCurrentAnswer)
            const resp = await self.retrieveAnswer(self.getCurrentAnswer.id);
            if (resp.status == 200 || resp.status == 201) {
              self.$bvToast.toast(`Video recuperado correctamente`, {
                title: `Excelente`,
                variant: "primary",
                solid: false,
              });
              setTimeout(() => {
                self.closeModal();
                self.$emit("answerRetrieved");
              }, 1000);
            }
          }
        })
        .catch((err) => {
          return err;
        });
    },
  },
};
</script>

<style></style>
